import * as actionTypes from "../action-types";

export const getPartnerDetails = payload => ({ type: actionTypes.GET_PARTNER_DETAILS, payload });
export const setPartnerDetails = payload => ({ type: actionTypes.SET_PARTNER_DETAILS, payload });